import {action, makeAutoObservable} from "mobx";
import ProductRulesApi, {ISavedRule} from "../../../api/ProductRulesApi";
import {IRuleInputOption} from "../../../components/rule/AsyncRuleInputSelection";
import Rule, {IRuleUnitOption} from "./Rule";

export interface IExampleValue {
    text: string
    product_id: string
    sku_id: string
    product_name?: string
}

export class RuleInput {
    private _rule_obj: Rule;

    constructor(
        rule: Rule,
        saved_rule: ISavedRule | null,
        input_units?: IRuleUnitOption[]
    ) {
        this._rule_obj = rule;
        if (saved_rule) {
            if (saved_rule.input_title && saved_rule.input_name && saved_rule.input_type) {
                this._rule = {
                    input_title: saved_rule.input_title,
                    input_name: saved_rule.input_name,
                    input_type: saved_rule.input_type
                };
            }
        }
        if (input_units) {
            if (saved_rule && saved_rule.input_unit_option) {
                this._input_unit_option = saved_rule.input_unit_option
            }
            this._input_unit_options = input_units;
        }
        makeAutoObservable(this)
    }

    private _input_unit_options?: IRuleUnitOption[];

    get input_unit_options(): IRuleUnitOption[] | undefined {
        return this._input_unit_options;
    }

    private _input_unit_option?: IRuleUnitOption;

    get input_unit_option(): IRuleUnitOption | undefined {
        return this._input_unit_option;
    }

    set input_unit_option(value: IRuleUnitOption | undefined) {
        this._input_unit_option = value;
        if (this.rule) {
            this._rule_obj.setRuleInput({
                input_name: this.rule.input_name,
                input_type: this.rule.input_type,
                input_title: this.rule.input_title
            })
        }

    }

    private _exampleValue?: IExampleValue;

    get exampleValue(): IExampleValue | undefined {
        return this._exampleValue;
    }

    private _isLoading = false;

    get isLoading(): boolean {
        return this._isLoading;
    }

    private _rule: IRuleInputOption | undefined;

    get rule(): IRuleInputOption | undefined {
        return this._rule;
    }

    get isInputValueExist() {
        return !!this._rule
    }

    public loadExampleValue() {
        if (this._rule && !this._isLoading) {
            if (!this._exampleValue) {
                this._isLoading = true;
                ProductRulesApi.getExample({
                    output_type: this._rule_obj.type,
                    ozon_attribute_id: this._rule_obj.ozon_attribute_id,
                    ozon_category_id: this._rule_obj.category_id
                }).then(action((response) => {
                    const data = response.data.data
                    this._isLoading = false;
                    if (data) {
                        this._exampleValue = data;
                    }
                }));
            }
        }
    }


}